import React, { useRef } from "react";
import styles from "./TopBar.module.css";

export default function TopBar({
  onExportPDF,
  onExportProject,
  onImportProject,
  onExportVideo,
  videoExport,
  saveState,
}) {
  const fileInputRef = useRef(null);
  const isRecording = videoExport?.inProgress;

  return (
    <header className={styles.bar}>
      <div className={styles.left}>
        <span className={`${styles.brand} text-headline-md`}>FrameFlow</span>
        <span className={`${styles.saveIndicator} text-label-sm`}>
          <span
            className={`${styles.saveDot} ${
              saveState === "saving" ? styles.saveDotBusy : ""
            }`}
          />
          {saveState === "saving" ? "Guardando…" : "Guardado"}
        </span>
      </div>

      <div className={styles.right}>
        <button className={`${styles.exportButton} text-label-md`} onClick={onExportPDF}>
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            picture_as_pdf
          </span>
          Exportar PDF
        </button>

        <button className={`${styles.secondaryButton} text-label-md`} onClick={onExportProject}>
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            save
          </span>
          Exportar proyecto
        </button>

        <button
          className={`${styles.secondaryButton} text-label-md`}
          onClick={onExportVideo}
          disabled={isRecording}
          title="Exporta la animática como video WebM (usa la duración de cada frame)"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            movie
          </span>
          {isRecording
            ? `Grabando ${videoExport.progress?.current ?? 0}/${videoExport.progress?.total ?? 0}…`
            : "Exportar video"}
        </button>

        <button
          className={`${styles.secondaryButton} text-label-md`}
          onClick={() => fileInputRef.current?.click()}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            folder_open
          </span>
          Cargar proyecto
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".frameflow,application/json"
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files?.[0];
            onImportProject(file);
            e.target.value = "";
          }}
        />

        <button className={styles.iconButton} title="Ajustes">
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
            settings
          </span>
        </button>
      </div>
    </header>
  );
}
